
import Typography from '@mui/material/Typography';


export const TextDrugCitalopram = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Citalopram is used to treat depression. Citalopram is in a class of antidepressants called selective serotonin reuptake inhibitors (SSRIs). 
It works by increasing the amount of serotonin, a natural substance in the brain that helps maintain mental balance.

<br /><br />



Sources: <br /><br />
https://medlineplus.gov/druginfo/meds/a699001.html
</Typography>

</div>

)
}